/*
 * twitter-entities.js
 * This function converts a tweet with "entity" metadata
 * from plain text to linkified HTML.
 *
 * See the documentation here: http://dev.twitter.com/pages/tweet_entities
 * Basically, add ?include_entities=true to your timeline call
 *
 * Copyright 2010, Wade Simmons
 * Licensed under the MIT license
 * http://wades.im/mons
 *
 * Modified by Andrew Suzuki
 *
 * Found at:
 * https://gist.github.com/wadey/442463
 */

/* eslint-disable */

function escapeHTML (str) {
  return str
    .replace(/&/g, '&amp;')
    .replace(/'/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

export default function parse (text, entities) {
  if (!entities) {
    return escapeHTML(text)
  }

  // This is very naive, should find a better way to parse this
  const index_map = {}

  const { urls, hashtags, user_mentions } = entities

  urls.forEach(entry => {
    index_map[entry.indices[0]] = [entry.indices[1], function (text) {
      return '<a color="red" href="' + escapeHTML(entry.url) + '" target="_blank">' + escapeHTML(text) + '</a>'
    }]
  })

  hashtags.forEach(entry => {
    index_map[entry.indices[0]] = [entry.indices[1], function (text) {
      return '<a href="http://twitter.com/search?q=' + escape('#' + entry.text) + '" target="_blank">' + escapeHTML(text) + '</a>'
    }]
  })

  user_mentions.forEach(entry => {
    index_map[entry.indices[0]] = [entry.indices[1], function (text) {
      return '<a title="' + escapeHTML(entry.name) + '" href="http://twitter.com/' + escapeHTML(entry.screen_name) + '" target="_blank">' + escapeHTML(text) + '</a>'
    }]
  })

  let result = ''
  let last_i = 0
  let i = 0

  // iterate through the string looking for matches in the index_map
  for (i = 0; i < text.length; i++) {
    var ind = index_map[i]
    if (ind) {
      var end = ind[0]
      var func = ind[1]
      if (i > last_i) {
        result += escapeHTML(text.substring(last_i, i))
      }
      result += func(text.substring(i, end))
      i = end - 1
      last_i = end
    }
  }

  if (i > last_i) {
    result += escapeHTML(text.substring(last_i, i))
  }

  return result
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/twitterEntities.js